import {Info} from '../model/shared/transaction/info';
import {TransactionDetail} from '../model/shared/transaction/transaction';
import {BaseResponse} from './internal/baseresponse';
export class TransactionSaveResult extends BaseResponse {
  data: TransactionDetail;
}



// WEBPACK FOOTER //
// ./src/app/response/transactionsaveresult.ts